import React from 'react';
import styled from '@emotion/styled';
import { colors, fontSize } from '../../../../global/variables';

const { transparentGrey } = colors;
const { small } = fontSize;

const StyledSpecItem = styled.div`
  padding: 0.5rem;
  background: ${transparentGrey};
  border-radius: 0.12rem;
`;

const StyledSpecLabel = styled.strong`
  color: rgba(15, 22, 33, 0.5);
  font-size: ${small};
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

const StyledSpecValue = styled.span`
  font-weight: 500;
`;

const EVSpecificationItem = ({ icon: IconComponent, label, value, unit = '', testId }) => {
  if (value == null && value !== 0) return null;

  return (
    <StyledSpecItem data-test-id={testId}>
      <StyledSpecLabel>
        {IconComponent && <IconComponent size={14} />} {label}
      </StyledSpecLabel>
      <StyledSpecValue>
        {value}
        {unit && ` ${unit}`}
      </StyledSpecValue>
    </StyledSpecItem>
  );
};

export default EVSpecificationItem;
